import React, { useState } from "react";
import Search from "./Search.js";
import Header from "./Header.js";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

function HomeSearch() {
  localStorage.removeItem("search");

  return (
    <Container>
      <Header />
      <Row className="homeSearch justify-content-center">
        <Col className="d-flex align-self-center flex-column" xs={12} md={8}>
          <h2>Judgement Summarise</h2>
          <Search />
          <p>
          Please enter Indian Kanoon link or the judgement text from any other source.
          </p>
        </Col>
      </Row>
    </Container>
  );
}

export default HomeSearch;
